import { createReducer } from '@reduxjs/toolkit'
import {
  AccountActions,
  InternalAccountActions,
} from '@store/reducers/account/actions'

import type { AccountState, OtpState } from './types'

export const accountReducer = createReducer<AccountState>(
  { otp: null, emails: null },
  (builder) => {
    builder
      .addCase(InternalAccountActions.clearOtp, (state) => ({
        ...state,
        otp: null,
      }))
      .addCase(InternalAccountActions.setOtp, (state, { payload: otp }) => ({
        ...state,
        otp,
      }))
      .addCase(InternalAccountActions.updateOtp, (state, { payload }) => ({
        ...state,
        otp: { ...(state.otp || {}), ...(payload as OtpState) },
      }))
      .addCase(InternalAccountActions.setEmails, (state, { payload }) => ({
        ...state,
        emails: payload,
      }))
      .addCase(AccountActions.clearOtpError, (state) => {
        if (!state?.otp?.error) {
          return
        }
        state.otp.error = null
      })
  }
)
